/* ============================================================
   OVER VIGILANT — SALES MACHINE JS
   Purchase notifications, visitor counter, spin wheel, urgency
   ============================================================ */
(function() {
  'use strict';

  /* ---------- CONFIG ---------- */
  const CONFIG = {
    // US cities for purchase notifications
    cities: [
      'Dallas, TX', 'Atlanta, GA', 'Phoenix, AZ', 'Denver, CO', 'Nashville, TN',
      'Charlotte, NC', 'Houston, TX', 'Tampa, FL', 'San Diego, CA', 'Columbus, OH',
      'Virginia Beach, VA', 'Colorado Springs, CO', 'Jacksonville, FL', 'San Antonio, TX',
      'Memphis, TN', 'Louisville, KY', 'Oklahoma City, OK', 'Kansas City, MO',
      'Fayetteville, NC', 'Killeen, TX', 'Norfolk, VA', 'El Paso, TX'
    ],
    // Product names for notifications
    products: [
      'OV 04 Chainmail AOP Tee', 'Ember Chainmail Hoodie', 'OV 01 Meridian AOP Polo',
      'Infinity Drop Bomber', 'Complete the Cycle Tee', 'OV Spartan Patch',
      'Tactical Duffle Bag', 'OV Chainmail Socks', 'Ghost Battalion Cap'
    ],
    firstNames: ['Marcus', 'Jake', 'Tyler', 'Chris', 'Derek', 'Ryan', 'Alex', 'Jordan', 'Cody', 'Blake', 'Trevor', 'Shane', 'Dustin', 'Kyle', 'Brandon'],
    notificationInterval: 25000, // 25 seconds
    notificationDuration: 6000,  // 6 seconds visible
  };

  /* ---------- PURCHASE NOTIFICATIONS ---------- */
  function randomItem(arr) { return arr[Math.floor(Math.random() * arr.length)]; }
  function randomTime() {
    const mins = Math.floor(Math.random() * 59) + 2;
    return mins + ' minutes ago';
  }

  function showPurchaseNotification() {
    // Don't show if spin modal or exit modal is open
    if (document.querySelector('.ov-spin-overlay.active') || 
        document.querySelector('.ov-exit-modal.active')) return;

    const toast = document.createElement('div');
    toast.className = 'ov-purchase-toast';
    toast.innerHTML = `
      <div class="ov-toast-text">
        <strong>${randomItem(CONFIG.firstNames)} from ${randomItem(CONFIG.cities)}</strong><br>
        purchased ${randomItem(CONFIG.products)}<br>
        <span class="ov-toast-time">${randomTime()} • Verified Buyer</span>
      </div>
    `;
    document.body.appendChild(toast);
    
    setTimeout(() => toast.classList.add('show'), 100);
    setTimeout(() => {
      toast.classList.remove('show');
      setTimeout(() => toast.remove(), 500);
    }, CONFIG.notificationDuration);
  }

  // Start notifications after 8 second delay
  setTimeout(() => {
    showPurchaseNotification();
    setInterval(showPurchaseNotification, CONFIG.notificationInterval);
  }, 8000);

  /* ---------- LIVE VISITOR COUNTER ---------- */
  function initVisitorCounter() {
    // Add to product pages
    const productForm = document.querySelector('.product-form, [class*="product-form"]');
    if (!productForm) return;

    const baseCount = Math.floor(Math.random() * 30) + 15;
    const counter = document.createElement('div');
    counter.className = 'ov-visitor-counter';
    counter.innerHTML = `<span class="ov-pulse-dot"></span><span class="ov-count">${baseCount}</span> operators viewing this now`;
    
    productForm.parentNode.insertBefore(counter, productForm);

    // Fluctuate the count
    let current = baseCount;
    setInterval(() => {
      current += Math.floor(Math.random() * 7) - 3;
      current = Math.max(8, Math.min(60, current));
      counter.querySelector('.ov-count').textContent = current;
    }, 8000);
  }

  /* ---------- STOCK URGENCY ---------- */
  function initStockUrgency() {
    const productForm = document.querySelector('.product-form, [class*="product-form"]');
    if (!productForm) return;

    const urgency = document.createElement('div');
    urgency.className = 'ov-stock-urgency';
    const stockLeft = Math.floor(Math.random() * 5) + 2;
    urgency.textContent = `Only ${stockLeft} left in stock — order soon`;
    productForm.parentNode.insertBefore(urgency, productForm);
  }

  /* ---------- SPIN WHEEL ---------- */
  const PRIZES = [
    { text: '10% OFF', code: 'OV-SPIN-X5PZEPAZ', color: '#C9971C' },
    { text: '15% OFF', code: 'OV-SPIN-WT3EJAEW', color: '#8A6A12' },
    { text: '5% OFF', code: 'OV-SPIN-HDVYUXMJ', color: '#C9971C' },
    { text: '20% OFF', code: 'OV-SPIN-2QXT5MCE', color: '#E8B84B' },
    { text: '10% OFF', code: 'OV-SPIN-X5PZEPAZ', color: '#8A6A12' },
    { text: 'FREE SHIP', code: 'SPINFREE', color: '#C9971C' },
  ];

  function initSpinWheel() {
    // Don't show if already spun (localStorage)
    if (localStorage.getItem('ov_spun')) return;

    // Create overlay
    const overlay = document.createElement('div');
    overlay.className = 'ov-spin-overlay';
    overlay.innerHTML = `
      <div class="ov-spin-modal">
        <button class="ov-spin-close" aria-label="Close">×</button>
        <h2>SPIN TO WIN</h2>
        <p>Try your luck, operator. Win up to 20% off your first order.</p>
        <div class="ov-wheel-container">
          <div class="ov-wheel-pointer"></div>
          <div class="ov-wheel" id="ovWheel"></div>
        </div>
        <button class="ov-spin-btn" id="ovSpinBtn">SPIN NOW</button>
        <div id="ovSpinResult" style="display:none;">
          <p style="color:#E8B84B; font-family:'Oswald'; text-transform:uppercase; margin-top:15px;">You won!</p>
          <div class="ov-discount-code" id="ovDiscountCode"></div>
          <p style="font-size:0.8rem;">Use this code at checkout. One per customer.</p>
        </div>
      </div>
    `;
    document.body.appendChild(overlay);

    // Build wheel segments
    const wheel = overlay.querySelector('#ovWheel');
    const segmentAngle = 360 / PRIZES.length;
    let gradientParts = [];
    PRIZES.forEach((prize, i) => {
      const start = i * segmentAngle;
      const end = (i + 1) * segmentAngle;
      gradientParts.push(`${prize.color} ${start}deg ${end}deg`);
    });
    wheel.style.background = `conic-gradient(${gradientParts.join(', ')})`;

    // Add prize labels
    PRIZES.forEach((prize, i) => {
      const label = document.createElement('div');
      label.style.cssText = `
        position:absolute; top:50%; left:50%;
        transform: rotate(${i * segmentAngle + segmentAngle/2}deg) translateY(-100px);
        transform-origin: 0 0;
        font-family:'Oswald'; font-size:0.7rem; font-weight:600;
        color:#0A0A0B; text-transform:uppercase; letter-spacing:0.05em;
        white-space:nowrap;
      `;
      label.textContent = prize.text;
      wheel.appendChild(label);
    });

    // Show after 15 seconds (or on exit intent for faster trigger)
    let shown = false;
    function showWheel() {
      if (shown || localStorage.getItem('ov_spun')) return;
      shown = true;
      overlay.classList.add('active');
    }
    setTimeout(showWheel, 15000);

    // Spin logic
    const spinBtn = overlay.querySelector('#ovSpinBtn');
    spinBtn.addEventListener('click', function() {
      spinBtn.disabled = true;
      spinBtn.textContent = 'SPINNING...';
      
      // Random prize (weighted toward smaller discounts)
      const weights = [30, 20, 25, 5, 15, 5]; // 10%, 15%, 5%, 20%, 10%, free ship
      let rand = Math.random() * 100;
      let prizeIndex = 0;
      for (let i = 0; i < weights.length; i++) {
        rand -= weights[i];
        if (rand <= 0) { prizeIndex = i; break; }
      }

      // Calculate rotation (5 full spins + land on prize)
      const targetAngle = 360 * 5 + (360 - (prizeIndex * segmentAngle + segmentAngle/2));
      wheel.style.transform = `rotate(${targetAngle}deg)`;

      setTimeout(() => {
        const prize = PRIZES[prizeIndex];
        overlay.querySelector('#ovDiscountCode').textContent = prize.code;
        overlay.querySelector('#ovSpinResult').style.display = 'block';
        spinBtn.style.display = 'none';
        localStorage.setItem('ov_spun', 'true');
        localStorage.setItem('ov_discount', prize.code);
      }, 4200);
    });

    // Close
    overlay.querySelector('.ov-spin-close').addEventListener('click', () => {
      overlay.classList.remove('active');
    });
  }

  /* ---------- EXIT INTENT ---------- */
  function initExitIntent() {
    if (localStorage.getItem('ov_exit_shown')) return;
    
    let exitModal = null;
    
    document.addEventListener('mouseout', function(e) {
      if (e.clientY <= 0 && !localStorage.getItem('ov_exit_shown') && 
          !document.querySelector('.ov-spin-overlay.active')) {
        
        if (!exitModal) {
          exitModal = document.createElement('div');
          exitModal.className = 'ov-exit-modal';
          exitModal.innerHTML = `
            <div class="ov-spin-modal">
              <button class="ov-spin-close" aria-label="Close">×</button>
              <h2>WAIT, OPERATOR</h2>
              <p>Before you go — take 10% off your first order.</p>
              <div class="ov-discount-code">STAYVIGILANT10</div>
              <button class="ov-spin-btn" onclick="this.closest('.ov-exit-modal').classList.remove('active')">CLAIM MY DISCOUNT</button>
            </div>
          `;
          document.body.appendChild(exitModal);
          exitModal.querySelector('.ov-spin-close').addEventListener('click', () => {
            exitModal.classList.remove('active');
          });
        }
        
        exitModal.classList.add('active');
        localStorage.setItem('ov_exit_shown', 'true');
      }
    });
  }

  /* ---------- INIT ---------- */
  function init() {
    initVisitorCounter();
    initStockUrgency();
    initSpinWheel();
    initExitIntent();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* ---------- COLLECTION CARD WHITE BOX FIX ---------- */
(function() {
  var css = `
    .collection-list .card__heading a,
    .collection-list__item .card__heading {
      background: rgba(10,10,11,0.85) !important;
      color: #C9971C !important;
      padding: 0.6rem 1.2rem !important;
      border: 1px solid rgba(201,151,28,0.4) !important;
      text-transform: uppercase !important;
      letter-spacing: 0.15em !important;
      font-family: 'Oswald', sans-serif !important;
      display: inline-block !important;
    }
    .card__content .card__heading {
      background: transparent !important;
    }
  `;
  var style = document.createElement('style');
  style.textContent = css;
  document.head.appendChild(style);
})();
